import { Box, Flex, Image, Text } from '@chakra-ui/react'
import React from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { ROUTES } from '../../contants'

export const Nav = () => {
  return (
    <Flex
      pos="absolute"
      bottom="5px"
      left="0"
      w="100%"
      align="center"
      justify="space-between"
      px="2.5rem"
      h="6rem"
      bg="#F7F7F7">
      {PAGES.map((item) => (
        <React.Fragment key={item.path}>
          {item.type === 'CENTER_ICON' ? (
            <CenterIcon />
          ) : (
            <NavItem path={item.path} icon={item.icon} name={item.name} />
          )}
        </React.Fragment>
      ))}
    </Flex>
  )
}

type NavItemProps = {
  icon: string
  name: string
  path: string
}

const NavItem = ({ name, icon, path }: NavItemProps) => {
  const location = useLocation()
  const isCurrentPath = location.pathname === path

  return (
    <Link to={path || '#'}>
      <Box cursor="pointer">
        <Flex justify="center">
          <svg
            width="18"
            height="19"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d={icon} fill={isCurrentPath ? '#2E279D' : '#B2B2B2'} />
          </svg>
        </Flex>
        <Text
          fontSize="1rem"
          mt="7px"
          textAlign="center"
          color={isCurrentPath ? '#2E279D' : '#B2B2B2'}>
          {name}
        </Text>
      </Box>
    </Link>
  )
}

const CenterIcon = () => {
  const history = useHistory()
  return (
    <Flex
      onClick={() => history.push(ROUTES.insurance)}
      pos="relative"
      cursor="pointer"
      top="-3rem"
      justify="center"
      align="center"
      w="6rem"
      h="6rem"
      bg="brand.blue"
      boxShadow="0px 4px 4px rgba(0, 0, 0, 0.12)"
      rounded="50%">
      <Image src="/icons/plus.svg" />
    </Flex>
  )
}

const PAGES = [
  {
    icon: 'M16 17.0003V7.79933L9 2.27733L2 7.79933V17.0003H16ZM18 18.0003C18 18.2655 17.8946 18.5199 17.7071 18.7074C17.5196 18.895 17.2652 19.0003 17 19.0003H1C0.734784 19.0003 0.48043 18.895 0.292893 18.7074C0.105357 18.5199 7.92656e-08 18.2655 7.92656e-08 18.0003V7.31433C-6.00579e-05 7.16328 0.0340991 7.01418 0.0999132 6.87822C0.165727 6.74226 0.261486 6.62298 0.38 6.52933L8.38 0.218328C8.55655 0.0788187 8.77499 0.00292969 9 0.00292969C9.22501 0.00292969 9.44345 0.0788187 9.62 0.218328L17.62 6.52833C17.7386 6.62208 17.8345 6.74153 17.9003 6.87767C17.9661 7.01381 18.0002 7.16311 18 7.31433V18.0003ZM4 10.0003H6C6 10.796 6.31607 11.559 6.87868 12.1216C7.44129 12.6843 8.20435 13.0003 9 13.0003C9.79565 13.0003 10.5587 12.6843 11.1213 12.1216C11.6839 11.559 12 10.796 12 10.0003H14C14 11.3264 13.4732 12.5982 12.5355 13.5359C11.5979 14.4735 10.3261 15.0003 9 15.0003C7.67392 15.0003 6.40215 14.4735 5.46447 13.5359C4.52678 12.5982 4 11.3264 4 10.0003Z',
    name: 'Home',
    path: '/dashboard'
  },
  {
    icon: 'M0.783 1.826L9 0L17.217 1.826C17.4391 1.87536 17.6377 1.99897 17.78 2.1764C17.9224 2.35384 18 2.57452 18 2.802V12.789C17.9999 13.7767 17.756 14.7492 17.2899 15.62C16.8238 16.4908 16.1499 17.2331 15.328 17.781L9 22L2.672 17.781C1.85027 17.2332 1.17646 16.4911 0.710348 15.6205C0.244236 14.7498 0.000236356 13.7776 0 12.79V2.802C3.90378e-05 2.57452 0.0776379 2.35384 0.21999 2.1764C0.362341 1.99897 0.560937 1.87536 0.783 1.826ZM2 3.604V12.789C2.00001 13.4475 2.16257 14.0957 2.47326 14.6763C2.78395 15.2568 3.23315 15.7517 3.781 16.117L9 19.597L14.219 16.117C14.7667 15.7518 15.2158 15.2571 15.5265 14.6767C15.8372 14.0964 15.9998 13.4483 16 12.79V3.604L9 2.05L2 3.604ZM10 9H13L8 16V11H5L10 4V9Z',
    name: 'Policies',
    path: ROUTES.policies.base
  },
  {
    type: 'CENTER_ICON',
    name: '',
    icon: '',
    path: ''
  },
  {
    icon: 'M19 0C19.552 0 20 0.448 20 1V15C20 15.552 19.552 16 19 16H4.455L0 19.5V1C0 0.448 0.448 0 1 0H19ZM18 2H2V15.385L3.763 14H18V2ZM8.515 4.412L8.962 5.1C7.294 6.003 7.323 7.452 7.323 7.764C7.478 7.744 7.641 7.74 7.803 7.755C8.705 7.839 9.416 8.58 9.416 9.5C9.416 10.466 8.632 11.25 7.666 11.25C7.129 11.25 6.616 11.005 6.292 10.66C5.777 10.114 5.5 9.5 5.5 8.505C5.5 6.755 6.728 5.187 8.515 4.412ZM13.515 4.412L13.962 5.1C12.294 6.003 12.323 7.452 12.323 7.764C12.478 7.744 12.641 7.74 12.803 7.755C13.705 7.839 14.416 8.58 14.416 9.5C14.416 10.466 13.632 11.25 12.666 11.25C12.129 11.25 11.616 11.005 11.292 10.66C10.777 10.114 10.5 9.5 10.5 8.505C10.5 6.755 11.728 5.187 13.515 4.412Z',
    name: 'Quotes',
    path: ROUTES.quotes.base
  },
  {
    icon: 'M1.83933 15.9998C1.4166 15.2688 1.08799 14.4873 0.861328 13.6738C1.35464 13.4229 1.76892 13.0404 2.05836 12.5687C2.34779 12.097 2.50109 11.5544 2.5013 11.0009C2.50151 10.4475 2.34861 9.90477 2.05953 9.43282C1.77045 8.96088 1.35645 8.57809 0.863328 8.32682C1.31536 6.69231 2.17606 5.19977 3.36433 3.98982C3.82842 4.29155 4.36695 4.45898 4.92031 4.4736C5.47367 4.48822 6.02028 4.34945 6.49966 4.07265C6.97904 3.79586 7.37248 3.39182 7.63646 2.90526C7.90043 2.41871 8.02463 1.8686 7.99533 1.31582C9.63744 0.891445 11.3606 0.892133 13.0023 1.31782C12.9733 1.87059 13.0977 2.42061 13.3619 2.90703C13.6261 3.39345 14.0197 3.7973 14.4992 4.07388C14.9786 4.35047 15.5253 4.48901 16.0786 4.47417C16.6319 4.45934 17.1704 4.2917 17.6343 3.98982C18.2133 4.57982 18.7273 5.25082 19.1593 5.99982C19.5923 6.74882 19.9163 7.52982 20.1373 8.32582C19.644 8.57672 19.2297 8.9592 18.9403 9.43093C18.6509 9.90266 18.4976 10.4453 18.4974 10.9987C18.4971 11.5522 18.65 12.0949 18.9391 12.5668C19.2282 13.0388 19.6422 13.4216 20.1353 13.6728C19.6833 15.3073 18.8226 16.7999 17.6343 18.0098C17.1702 17.7081 16.6317 17.5407 16.0784 17.526C15.525 17.5114 14.9784 17.6502 14.499 17.927C14.0196 18.2038 13.6262 18.6078 13.3622 19.0944C13.0982 19.5809 12.974 20.131 13.0033 20.6838C11.3612 21.1082 9.6381 21.1075 7.99633 20.6818C8.02537 20.1291 7.90093 19.579 7.63675 19.0926C7.37257 18.6062 6.97897 18.2023 6.4995 17.9258C6.02003 17.6492 5.47338 17.5106 4.92005 17.5255C4.36673 17.5403 3.82829 17.7079 3.36433 18.0098C2.77332 17.4068 2.26092 16.7314 1.83933 15.9998ZM7.49933 16.1958C8.56496 16.8105 9.36617 17.7968 9.74933 18.9658C10.2483 19.0128 10.7493 19.0138 11.2483 18.9668C11.6317 17.7977 12.4333 16.8113 13.4993 16.1968C14.5645 15.5805 15.8199 15.3793 17.0243 15.6318C17.3143 15.2238 17.5643 14.7888 17.7723 14.3338C16.9518 13.4173 16.4984 12.23 16.4993 10.9998C16.4993 9.73982 16.9693 8.56282 17.7723 7.66582C17.5629 7.21097 17.3118 6.77646 17.0223 6.36782C15.8186 6.62013 14.5641 6.4193 13.4993 5.80382C12.4337 5.18919 11.6325 4.20281 11.2493 3.03382C10.7503 2.98682 10.2493 2.98582 9.75033 3.03282C9.36693 4.20197 8.56533 5.18838 7.49933 5.80282C6.43411 6.41914 5.17881 6.62034 3.97433 6.36782C3.68489 6.77611 3.43446 7.21069 3.22633 7.66582C4.0469 8.58238 4.50021 9.76961 4.49933 10.9998C4.49933 12.2598 4.02933 13.4368 3.22633 14.3338C3.4358 14.7887 3.68687 15.2232 3.97633 15.6318C5.18005 15.3795 6.43454 15.5803 7.49933 16.1958ZM10.4993 13.9998C9.70368 13.9998 8.94062 13.6838 8.37801 13.1211C7.8154 12.5585 7.49933 11.7955 7.49933 10.9998C7.49933 10.2042 7.8154 9.44111 8.37801 8.8785C8.94062 8.31589 9.70368 7.99982 10.4993 7.99982C11.295 7.99982 12.058 8.31589 12.6206 8.8785C13.1833 9.44111 13.4993 10.2042 13.4993 10.9998C13.4993 11.7955 13.1833 12.5585 12.6206 13.1211C12.058 13.6838 11.295 13.9998 10.4993 13.9998ZM10.4993 11.9998C10.7645 11.9998 11.0189 11.8945 11.2064 11.7069C11.394 11.5194 11.4993 11.265 11.4993 10.9998C11.4993 10.7346 11.394 10.4803 11.2064 10.2927C11.0189 10.1052 10.7645 9.99982 10.4993 9.99982C10.2341 9.99982 9.97976 10.1052 9.79222 10.2927C9.60468 10.4803 9.49933 10.7346 9.49933 10.9998C9.49933 11.265 9.60468 11.5194 9.79222 11.7069C9.97976 11.8945 10.2341 11.9998 10.4993 11.9998Z',
    name: 'Settings',
    path: '/settings'
  }
]
